<template>
  <div :class="{ 'app-header': true, 'has-action': displaySearchAction }">
    <div class="menu-container">
      <ag-button
        class="menu-button"
        priority="subtle"
        @click="setMenu(true)"
      >
        <menu-icon size="32" />
      </ag-button>
      <app-menu :class="{ active: isMenuOpen }" @close="setMenu(false)" />
    </div>
    <div class="logo-container">
      <logo @click="routeTo('Recipes')" white />
    </div>
    <div class="nav-search" v-if="displaySearchAction">
      <ag-button priority="subtle" @click="onToggleSearch">
        <ag-icon>
          <search-icon />
        </ag-icon>
      </ag-button>
    </div>
    <div class="search" v-if="showSearch">
      <ag-icon class="input-icon">
        <search-icon />
      </ag-icon>
      <input type="text" ref="search" :value="query" placeholder="Search recipes..." @input="onSearch" />
      <ag-button priority="subtle" @click="onToggleSearch">
        <ag-icon class="close-search">
          <x-icon />
        </ag-icon>
      </ag-button>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import { XIcon, MenuIcon, SearchIcon } from "vue-feather-icons";
  import AppMenu from "./Menu";
  import Logo from "./Logo";
  import { RECIPES } from "../store/actions";

  export default {
    name: "AppHeader",
    props: {
      displaySearchAction: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      isMenuOpen: false,
      showSearch: false,
    }),
    mounted() {
      if(this.query) {
        this.showSearch = true;
        this.$nextTick(
          function () {
            this.$refs.search.focus();
          }.bind(this)
        );
      }
    },
    computed: {
      ...mapState("user", ["isAuthenticated"]),
      ...mapState("recipes", ["query"])
    },
    methods: {
      routeTo(route) {
        this.$router.currentRoute.name !== route &&
          this.$router.push({ name: route });
      },
      setMenu(isMenuOpen) {
        this.isMenuOpen = isMenuOpen;
      },
      onSearch(e) {
        this.$store.dispatch(`recipes/${RECIPES.SET_QUERY}`, e.target.value);
      },
      onToggleSearch() {
        this.showSearch && this.$store.dispatch(`recipes/${RECIPES.SET_QUERY}`, null);
        this.showSearch = !this.showSearch;
        if(this.showSearch) {
          this.$nextTick(
            function () {
              this.$refs.search.focus();
            }.bind(this)
          );
        }
      }
    },
    components: { Logo, AppMenu, XIcon, MenuIcon, SearchIcon }
  };
</script>

<style scoped lang="scss">
  .app-header {
    color: $color-white;
    background: $color-purple-light;
    display: flex;
    align-items: center;
    font-size: 18px;
    position: relative;

    &.has-action {
      justify-content: space-between;
    }

    .logo {
      padding: 12px 16px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      cursor: pointer;

      svg {
        max-width: 80px;
      }
    }

    button {
      padding-top: 16px;
      padding-bottom: 16px;
      min-width: 0;
      height: 32px;
      box-sizing: content-box;
      border-radius: 0;

      svg {
        display: block;
      }
    }

    .menu-button {
      border-right: 1px solid rgba(255, 255, 255, 0.1);
    }

    .nav-search {
      display: flex;

      button {
        border-left: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 0;
      }
    }

    .search {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255,255,255,0.95);
      display: flex;
      align-items: center;

      input[type="text"] {
        flex-grow: 1;
        font-size: 24px;
        line-height: 24px;
        height: 24px;
        border: 0;
        padding: 20px 0 20px 60px;
        outline: 0;
        position: relative;
        z-index: 1;
        background: transparent;
        color: $color-purple-light;
        font-weight: 600;
        width: calc(100% - 60px);

        &::placeholder {
          font-style: oblique;
          font-weight: 400;
          color: #999;
        }
      }

      .input-icon {
        padding: 16px $gutter;
        height: 32px;
        position: absolute;
        top: 0;
        left: 0;

        svg {
          stroke: rgba($color-purple-light, 0.3);
        }
      }

      .close-search {
        svg {
          stroke: $color-primary;

        }
      }
    }
  }
</style>
